import { styled } from '@mui/material/styles'
import { Box, TextareaAutosize, TextField } from '@mui/material'

export const Wrapper = styled(Box)(`
  display: flex;
  flex-direction: column;
`)

export const TextFieldStyled = styled(TextField)(({ theme }) => (`
  
`))

export const TextFieldWrapper = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  & .MuiFormControl-root label {
    font-size:14px;
  }
  & .MuiInputBase-root {
    min-height: 32px;
    font-size:${theme.components.MuiTextField.styleOverrides.fontSize};
  }
  // & .MuiInput-underline:before {
  //   border-color:${theme.components.MuiTextField.styleOverrides.borderColor};
  // }
  & .MuiInput-underline:before {
    border-bottom:1px ${theme.components.MuiTextField.styleOverrides.borderColor} solid !important;
  }
  & input[type='number'],
  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
  }
  & input::placeholder,
  & textarea::placeholder {
    color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
    -webkit-text-fill-color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
    -moz-text-fill-color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
    opacity: 1; /* Firefox */
  }
  
  & input::-ms-input-placeholder,
  & textarea::-ms-input-placeholder { /* Edge 12 -18 */
    color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
    -webkit-text-fill-color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
    -moz-text-fill-color: ${theme.components.MuiTextField.styleOverrides.placeholderColor};
  }

  & input[disabled], & input[readonly],
  & textarea[disabled], & textarea[readonly] {
    color: ${theme.components.MuiTextField.styleOverrides.disabledColor};
    -webkit-text-fill-color: ${theme.components.MuiTextField.styleOverrides.disabledColor};
    -moz-text-fill-color: ${theme.components.MuiTextField.styleOverrides.disabledColor};
  }

`)

export const FormReq = styled('span')(`
  font-size: 12px;
  color: #DA2A52;
  padding-left:5px;
`)

export const IconWrap = styled(Box)(({ theme }) => `
  width:40px;
  height:40px;
  display: flex;
  justify-content: center;
  align-items: center;
  & img {
    max-width:20px;
    max-height:20px;
  }
`)

export const FormError = styled(Box)(`
  width:100%;
  display:block;
  line-height: 20px;

  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
  background-color: transparent !important;
`)

export const TextareaInput = styled(TextareaAutosize)(() => ({
  'label + &': {
    marginTop: 20
  },
  border: '1px solid #E4E7EC',
  // fontSize: 12,
  width: '100%',
  height: 35,
  padding: '8px 16px',
  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.12)'
}))

// export const FormLabel = styled('label')(`
//   font-style: normal;
//   font-weight: 300;
//   font-size: 14px;
//   line-height: 19px;
//   color: #000;
//   width:100%;
// `)

export const FormLabel = styled('label')(props => `
  text-transform: capitalize;
  font-weight: ${props?.bold ? '600' : '400'};
  color: ${props?.theme?.palette?.primary?.dark || '#333'};
`)

export const LabelWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
`)
